import 'normalize.css/normalize.css'
import 'prismjs/themes/prism.css'
import 'prismjs/themes/prism-okaidia.css'

import Vue from 'vue'
import App from './App'

import VueParticles from './vue-particles'
import VuePrism from 'vue-prism'
Vue.use(VueParticles, VuePrism)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js